import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import FieldTypes, {
  FIELD_LABELS,
  FIELD_ICONS,
  FIELD_DESCRIPTION,
  COLORS,
} from 'modules/connect-card/constants/field-types';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const QuestionSelectionModal = ({ onSelect, onClose }) => {
  const [t] = useTranslation('connectCard');
  const [selected, setSelected] = useState();

  const onSubmit = () => {
    return onSelect(selected);
  };

  return (
    <Modal
      maxWidth="md"
      title={t('add-question-heading', 'Add a question')}
      onClose={onClose}
      actions={
        <Button onClick={onSubmit} disabled={!selected}>
          {t('select', 'Select')}
        </Button>
      }
    >
      <Typography paragraph color="text.secondary">
        {t(
          'add-question-desc',
          'Choose the questions you would like to add to this Card from the list below',
        )}
      </Typography>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        {Object.keys(FieldTypes).map((key) => {
          const type = FieldTypes[key];
          const Icon = FIELD_ICONS[type];
          return (
            <Grid item xs={12} md={4} key={type}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  cursor: 'pointer',
                  height: '100%',
                  borderColor: selected === type && 'primary.main',
                }}
                onClick={() => setSelected(type)}
              >
                <Stack direction="row" spacing={1} mb={1}>
                  <Box
                    backgroundColor={COLORS[type].color}
                    borderRadius="50%"
                    width="24px"
                    height="24px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon
                      sx={{
                        color: 'white',
                        fontSize: 14,
                      }}
                    />
                  </Box>
                  <Typography fontWeight={500}>{FIELD_LABELS[type]}</Typography>
                </Stack>
                <Typography color="text.secondary">
                  {FIELD_DESCRIPTION[type]}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Modal>
  );
};

export default QuestionSelectionModal;
